import { render, staticRenderFns } from "./TemplateThumbnail.vue?vue&type=template&id=f104b5e6&scoped=true&"
import script from "./TemplateThumbnail.vue?vue&type=script&lang=js&"
export * from "./TemplateThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./TemplateThumbnail.vue?vue&type=style&index=0&id=f104b5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f104b5e6",
  null
  
)

export default component.exports